export function shouldShow(appointment_booking_id, appointment_booking_state) {
  return (
    typeof appointment_booking_id === 'undefined' ||
    appointment_booking_state === 'NO_SHOW'
  )
}
